// src/config/plans.ts
// Taxonomía única de planes y regla de inclusión.
import type { PlanType } from '../db/db';
import { PLANS, type PlanKey } from './pricing';

export const PLAN_ORDER: readonly PlanType[] = [
  'FREE',
  'NARANJA_PLUS',
  'ADVANCED_ACCOUNTING',
  'STUDIO_FIRM',
] as const;

export const PLAN_LABELS: Record<PlanType, string> = {
  FREE: 'Gratis',
  NARANJA_PLUS: 'Naranja Plus',
  ADVANCED_ACCOUNTING: 'Contabilidad Avanzada',
  STUDIO_FIRM: 'Zanahoria Studio',
};

export const PLAN_DESCRIPTIONS: Record<PlanType, string> = {
  FREE: 'POS, inventario, caja y restaurante. Sin nube.',
  NARANJA_PLUS: 'Nube, tienda pública, subastas, Drive, asignaciones y videollamadas.',
  ADVANCED_ACCOUNTING: 'Todo Plus + contabilidad avanzada, nómina y producción.',
  STUDIO_FIRM: 'Todo lo anterior + cartera multi-cliente para firmas contables.',
};

/** ¿El plan del usuario cubre el plan requerido? */
export function planIncludes(userPlan: PlanType | null | undefined, required: PlanType): boolean {
  // Un plan requerido desconocido NUNCA se concede.
  if (!PLAN_ORDER.includes(required as PlanType)) return false;
  const user = normalizePlan(userPlan);
  const userIndex = PLAN_ORDER.indexOf(user);
  const requiredIndex = PLAN_ORDER.indexOf(required);
  if (userIndex < 0 || requiredIndex < 0) return false;
  return userIndex >= requiredIndex;
}

/** Normaliza cualquier valor histórico o inválido a un PlanType vigente. */
export function normalizePlan(value: unknown): PlanType {
  const raw = String(value ?? '').trim().toUpperCase();
  if (raw === 'PRO') return 'NARANJA_PLUS';
  if (raw === 'ENTERPRISE') return 'ADVANCED_ACCOUNTING';
  if (raw === 'NARANJA_PLUS' || raw === 'ADVANCED_ACCOUNTING' || raw === 'STUDIO_FIRM') {
    return raw;
  }
  return 'FREE';
}

/** Plan inmediatamente inferior (para downgrades). */
export function previousPlan(plan: PlanType): PlanType {
  const index = PLAN_ORDER.indexOf(normalizePlan(plan));
  return index <= 0 ? 'FREE' : PLAN_ORDER[index - 1] as PlanType;
}

/** Precio mensual del plan (0 para FREE). */
export function planPrice(plan: PlanType): { coins: number; cop: number } {
  const key = normalizePlan(plan) as PlanKey;
  return PLANS[key];
}

/** ¿Es un plan pagado? */
export const isPaidPlan = (plan: PlanType | null | undefined): boolean =>
  normalizePlan(plan) !== 'FREE';
